import { inject, Injectable, signal } from '@angular/core';
import { Stamp, StampPayload } from '../interfaces/stamp.interface';
import { catchError, delay, map, of, tap, throwError } from 'rxjs';
import { PassportProfilePayload, StampProfile, StampProfilePayload } from '../interfaces/stamp-profile.interface';
import { BottomSheet, PopUp } from '../interfaces/passport.interface';
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/services/auth.service';

  // * MOCKS * //
//const ADD_STAMP_API_DATA: Stamp = {
//  interest_point: {
//    congrats_title: {
//      es: '¡Enhorabuena!',
//      en: 'Congratulations!'
//    },
//    congrats_description: {
//      es: 'Se ha registrado tu visita a',
//      en: 'Your visit to has been recorded'
//    },
//    title: {
//      es: 'Fonte do Sapo',
//      en: 'Fonte do Sapo'
//    }
//  },
//  descriptions: [
//    {
//      es: '<strong>El Lugar</strong><br>Un precioso jardín que nos proporciona uno de los paseos más bellos de Chaves-Verín. Junto a árboles autóctonos y otros más extraños se erigen el templete de la fuente, el antiguo balneario y la planta embotelladora.',
//      en: '<strong>The Place</strong><br>A beautiful garden that offers one of the most delightful walks in Chaves-Verín. Alongside native trees and others of more unusual kinds stand the small fountain pavilion, the old spa building, and the bottling plant.'
//    },
//    {
//      es: '<strong>Las aguas</strong><br>Son clasificadas como bicarbonatadas, sódicas, cálcicas, litínicas y acídulas. Se trata de aguas con efectos digestivos, diuréticos y relajantes del sistema nervioso.',
//      en: '<strong>The waters</strong><br>They are classified as bicarbonated, sodic, calcic, lithinic, and mildly acidic. These waters have digestive, diuretic, and relaxing effects on the nervous system.'
//    }
//  ],
//  image: {
//    es: '/assets/imgs/stamp.png',
//    en: '/assets/imgs/stamp.png'
//  }
//}

//const MY_STAMPS_API_DATA: StampProfile[] = [
//  {
//    id: 1,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: "DD/MM/YYYY"
//  },
//  {
//    id: 2,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: "DD/MM/YYYY"
//  },
//  {
//    id: 3,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 4,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 5,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 6,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 7,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 8,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 9,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 10,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 11,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  },
//  {
//    id: 12,
//    address: {
//      es: 'Ubicacion del sello en un maximo que no supere las 2 lineas del Dom para no saturar la info en la misma pagina web',
//      en: 'The seal should be placed on a maximum of two lines of the DOM (Document of Commerce) to avoid overloading the information on the same webpage'
//    },
//    image: {
//      es: '/assets/imgs/stamp.png',
//      en: '/assets/imgs/stamp.png'
//    },
//    str_stamped_at: null
//  }
//]

@Injectable({ providedIn: 'root' })
export class PassportService {
  private apiUrlBase: string = environment.apiUrlBase;
  
  private authService = inject(AuthService);
  private rest = inject(RestService);
  private http = inject(HttpClient);
  
  private _passportsEnabled = signal<boolean>(false);
  public passportsEnabled = this._passportsEnabled.asReadonly();

  private _passportPopup = signal<PopUp | null>(null);
  public passportPopup = this._passportPopup.asReadonly();

  private _passportBottomSheet = signal<BottomSheet | null>(null);
  public passportBottomSheet = this._passportBottomSheet.asReadonly();

  public enablePassports(){
    this._passportsEnabled.set(true);
  }

  public setPassportPopup(popup: PopUp){
    this._passportPopup.set(popup);
  }

  public setPassportBottomSheet(bottomSheet: BottomSheet){
    this._passportBottomSheet.set(bottomSheet);
  }

  public getPassportsList() {
    const params: any = {
      webuser_id: this.authService.userValue?.id,
    };
    
    if (this.rest.device.client) {
      params.client_id = this.rest.device.client;
    } else if (this.rest.device.distributorID) {
      params.distributor_id = this.rest.device.distributorID;
    }
    return this.http.get(`${this.apiUrlBase}/api/gamification/passports`, { params }).pipe(
      catchError((err) => {
        return throwError(() => new Error('Error getting passports list', { cause: err }));
      })
    );
  }

  public getBadgesByPassportId(id: number){
    const params: any = {
      webuser_id: this.authService.userValue?.id,
    };
    
    if (this.rest.device.client) {
      params.client_id = this.rest.device.client;
    } else if (this.rest.device.distributorID) {
      params.distributor_id = this.rest.device.distributorID;
    }
    
    return this.http.get(`${this.apiUrlBase}/api/gamification/passports/${id}/badges`, {params}).pipe(
      catchError((err) => {
        return throwError(() => new Error(`Error getting badges from passportId ${id}`, { cause: err }));
      })
    );
  }

  public sealByQrCode(qrCode: string){
    const payload: Partial<StampPayload> = {
      webuser_id: this.authService.userValue?.id,
      qr_code: qrCode
    };
    
    if (this.rest.device.client) {
      payload.client_id = this.rest.device.client;
    } else if (this.rest.device.distributorID) {
      payload.distributor_id = this.rest.device.distributorID;
    }

    return this.http.post(`${this.apiUrlBase}/api/gamification/badges/seal`, payload).pipe(
      catchError((err) => {
        return throwError(() => new Error(`Error sealing badge`, { cause: err }));
      })
    );
  }

  //public stampByQrFake(payload: StampPayload){
  //    return of(ADD_STAMP_API_DATA).pipe(delay(2000));
  //}

  //public getMyStampsFake(payload: StampProfilePayload){
  //  return of(MY_STAMPS_API_DATA).pipe(
  //    delay(2000),
  //    map(stampList => {
  //      const angles = Array.from({ length: stampList.length }, (_, i) => -15 + (30 / stampList.length) * i);
  //      angles.sort(() => Math.random() - 0.5);

  //      return stampList.map((stamp, index) => ({
  //        ...stamp,
  //        random_rotate: angles[index],
  //      }));
  //    })
  //  );
  //}

}